<div>
  <fieldset name="consumption">
    <div class="re-form-item-container">
      <div class="bold">{{'tmh.consumption.headingCalculate' | translate}}</div>
      <bdo-toggle-button
        [description]="('tmh.chargingConsumption.toggleConsumptionKnown') | translate"
        [enabled]="consumptionKnown()"
        [labelRight]="'tmh.chargingConsumption.toggleConsumptionKnown' | translate"
        (toggle)="onToggleConsumptionKnown()"
      ></bdo-toggle-button>

      @if (consumptionKnown()) {
        <div class="re-mt-20">
          <bdo-input [formControl]="parentForm.controls.chargingConsumption"
            ngDefaultControl
            [inputType]="INPUT_TYPE.NUMBER"
            [labelText]="'tmh.chargingConsumption.yearlyCharge' | translate"
            [id]="'chargingConsumption'">
          </bdo-input>
        </div>
      } @else {
        <div class="re-flex re-flex-col re-gap-20">
          <bdo-input [formControl]="parentForm.controls.kmPerYear"
            ngDefaultControl
            [inputType]="INPUT_TYPE.NUMBER"
            [labelText]="'tmh.chargingConsumption.kmPerYear' | translate"
            [id]="'chargingConsumption'">
          </bdo-input>
          <bdo-input [formControl]="parentForm.controls.consumptionPer100"
            ngDefaultControl
            [inputType]="INPUT_TYPE.NUMBER"
            [labelText]="'tmh.chargingConsumption.consumptionPer100' | translate"
            [id]="'chargingConsumption'"
            (blur)="null">
          </bdo-input>
          <bdo-input [formControl]="parentForm.controls.homeChargingPercentage"
            ngDefaultControl
            [inputType]="INPUT_TYPE.NUMBER"
            [labelText]="'tmh.chargingConsumption.homeChargingPercentage' | translate"
            [id]="'chargingConsumption'"
            (blur)="null">
          </bdo-input>
          @if (true) {
            <div
              class="re-mt-20"
              [innerHTML]="'tmh.chargingConsumption.calculatedConsumption' | translate: {consumption: calculatedConsumption || '___'}"
            ></div>
          }
        </div>
      }
    </div>

  </fieldset>
</div>
